// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Notice_wrapper__c8KV2"};